import {
  SET_PATH,
  SET_FILE_STRUCTURE,
  SET_LABELS,
  SET_FILE_PATH,
  SET_SELECTED_COMPANY,
  SET_LABEL_STATUS,
  BREADCRUMB_CHANGE,
  SET_FOLDER_PATH,
  SET_CHART_ACCOUNTS,
  SET_CSV_DATA,
  SET_EMAIL_UPLOAD_STATUS,
  SET_COMPANY_ID,
  SET_SELECTED_LABELS,
  SET_GRID_VIEW,
  DOCUMENT_TYPE_CHANGE,
  SET_LINKS_SIDEBAR_OPEN,
} from "../../constants/actionTypes";

const initialState ={
  isLinksSidebarOpen: false,
};

const home = (state = initialState, action) => {
  switch (action.type) {
    case SET_PATH:
      return {
        ...state,
        path: action.path,
      };
    case SET_FILE_STRUCTURE:
      return {
        ...state,
        fileTree: action.fileTree,
      };
    case SET_LABELS:
      return {
        ...state,
        allLabels: [...(action.allLabels || [])],
      };
    case SET_SELECTED_LABELS:
      return {
        ...state,
        selectedLabels: [...(action.selectedLabels || [])],
      };
    case SET_FILE_PATH:
      return {
        ...state,
        filePath: action.filePath,
      };
    case SET_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action.selectedCompany,
      };
    case SET_COMPANY_ID:
      return {
        ...state,
        companyId: action.companyId,
      };
    case SET_LABEL_STATUS:
      return {
        ...state,
        isLabelUpdated: action.isLabelUpdated,
      };
    case SET_EMAIL_UPLOAD_STATUS:
      return {
        ...state,
        isEmailDocumentUpload: action.isEmailDocumentUpload,
      };
    case BREADCRUMB_CHANGE:
      return {
        ...state,
        isBreadcrumbChange: action.isBreadcrumbChange,
      };
    case SET_FOLDER_PATH:
      return {
        ...state,
        folderPath: action.folderPath,
      };
    case SET_GRID_VIEW:
      return {
        ...state,
        gridView: action.gridView,
      };
    case SET_CHART_ACCOUNTS: {
      const selectedCompany = state.selectedCompany;
      const chartAccounts = state.chartAccounts || {};
      chartAccounts[selectedCompany] = action.accounts;
      return {
        ...state,
        chartAccounts,
      };
    }
    case SET_CSV_DATA:
      return {
        ...state,
        csvData: action.csvData,
      };
    case DOCUMENT_TYPE_CHANGE:
      return {
        ...state,
        hasDocumentTypeChange: action.hasDocumentTypeChange,
      };
    case SET_LINKS_SIDEBAR_OPEN:
      return {
        ...state,
        isLinksSidebarOpen: action.isLinksSidebarOpen,
      };
    default:
      return state;
  }
};

export default home;
